module.exports = __webpack_public_path__ + "img/zhengshu1.d87f4710.png";